module.exports = __webpack_public_path__ + "static/media/Captura.b8912abd.png";